import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login } from '../store/slices/authSlice';
import type { AppDispatch } from '../store/store';
import { LoginCredentials } from '../types/auth';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  const onFinish = async (values: LoginCredentials) => {
        try {
            const actionResult = await dispatch(login(values)).unwrap();
 
            // actionResult is now the User object directly
            if (actionResult.user?.role === 'administrator') {
                navigate('/admin/dashboard');
            } else {
                navigate('/dashboard');
            }
        } catch (error: any) {
            console.error(error);
        } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md shadow-lg">
        <div className="text-center mb-6">
          <img
            src="/vodovod-doboj-logo.png"
            alt="Vodovod Doboj"
            className="h-16 w-auto max-w-full mx-auto mb-6 object-contain"
          />
          <h2 className="text-2xl font-bold text-gray-900">
            Moj Vodovod Doboj
          </h2>
          <p className="text-gray-500 mt-2">Računi, očitavanja i obavještenja na jednom mjestu</p>
        </div>
        
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Unesite email' },
              { type: 'email', message: 'Unesite ispravan email' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="Email"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Unesite lozinku' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Lozinka"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
            >
              Prijavi se
            </Button>
          </Form.Item>
         

          <div className="text-center">
            <span className="text-gray-600">Nemate račun? </span>
            <Button type="link" onClick={() => navigate('/register')}>
              Registrujte se
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
